import styles from './OrderByDropDown.module.scss'

export default function OrderByDropdown({ activeOrderBy, toggleOrderBy }) {
  return (
    <div className="container">
      <div className={styles.orderWrap}>
        <label className="no-style" htmlFor="order">
          Järjestys:
        </label>
        <div className="select-wrap select-wrap--underline select-wrap--small">
          <select
            id="order"
            onChange={(e) => toggleOrderBy(e.target.value)}
            defaultValue={activeOrderBy}
          >
            <option
              value="name"
              defaultValue={{
                ...(activeOrderBy === 'name' ? 'selected' : false),
              }}
            >
              Nimi
            </option>
            <option
              value="date"
              defaultValue={{
                ...(activeOrderBy === 'date' ? 'selected' : false),
              }}
            >
              Uusimmat
            </option>
            <option
              value="rand"
              defaultValue={{
                ...(activeOrderBy === 'rand' ? 'selected' : false),
              }}
            >
              Satunnainen
            </option>
          </select>
        </div>
      </div>
    </div>
  )
}
